/*
  THIS FILE IS GENERATED !!

  #> npm run gen:meme-bundle
  #> NETLIFY_ENV=development npm run gen:meme-bundle
*/
/* eslint-disable */

export default [{"isShown":true,"imageSrc":"/static/content/uploads/arthur-fist.png","title":"Arthur Fist ","aspectRatio":"4:3","showTitle":true},{"isShown":true,"imageSrc":"/static/content/uploads/meme-test-lebron-4-3.png","title":"LeBron James WTF","aspectRatio":"4:3","showTitle":true},{"isShown":true,"imageSrc":"/static/content/uploads/meme-test-nick-young-1-1.jpg","title":"Nick Young Huh","aspectRatio":"1:1","showTitle":true},{"isShown":true,"imageSrc":"/static/content/uploads/meme-office-space-this-is-awkward.png","title":"Office Space Well...This is Awkward","aspectRatio":"4:3","showTitle":true},{"isShown":true,"imageSrc":"/static/content/uploads/meme-test-steve-urkel-16-9.png","title":"Steve Urkel Did I Do That","aspectRatio":"16:9","showTitle":true}];



// WEBPACK FOOTER //
// ./src/content/meme-bundle.js